import {getLocalePrefixes} from "@khan/i18n";

/**
 * Return the best language-tag match in active_set, or default else.
 *
 * @param locales a set of locales that are legal values.  We
 *        always return some string from the set, or else default.
 * @param locale the language-tag to match to a locale.  If
 *        it or some prefix of it (according to locale_prefixes())
 *        is in active_set, that gets returned.
 * @returns the best match from the set of locales, or "en" if a best match
 *          cannot be found.
 */
export const bestMatchLocale = (
    locales: ReadonlyArray<string>,
    locale: string,
): string => {
    // sync-start:best-match-locale 163857321 https://github.com/Khan/webapp/blob/master/services/content-library/rssfeeds/locale_util.go
    return (
        getLocalePrefixes(locale).find((candidate) => {
            return locales.includes(candidate);
        }) ?? "en"
    );
    // sync-end:best-match-locale
};
